<script>
import { gsap } from 'gsap';
import 'intersection-observer';
import scrollama from 'scrollama';
import debounce from 'lodash/debounce';

export default {
  name: 'FrameAnimation',
  data() {
    return {
      count: 0,
      scroller: scrollama(),
      gsapFrameTimeline: gsap.timeline({ defaults: { duration: 1 } }),
    };
  },
  mounted() {
    this.$el.closest('.frame-content').prepend(this.$el);
    this.setFrameAnimation();
    this.setScrollerSteps();
    window.addEventListener('resize', debounce(this.scroller.resize, 50));
  },
  methods: {
    setFrameAnimation() {
      this.gsapFrameTimeline.add(gsap.fromTo(['.frame-animation__sides'],
        {
          height: 0,
        },
        {
          height: '100%',
          duration: 0.50,
        }), 0);

      this.gsapFrameTimeline.add(gsap.fromTo(['.frame-animation__top-expand'],
        {
          width: '0%',
        },
        {
          width: '100%',
          duration: 0.50,
        }), 0);

      this.gsapFrameTimeline.add(gsap.fromTo(['.frame-animation__bottom'],
        {
          width: '0%',
        },
        {
          width: '100%',
          duration: 0.50,
        }), 0);

      this.gsapFrameTimeline.kill();
    },
    setScrollerSteps() {
      this.scroller
        .setup({
          step: '.frame-animation',
          offset: 0.25,
        })
        .onStepEnter((response) => {
          if (response.direction === 'down') {
            this.gsapFrameTimeline.restart();
          }
        })
        .onStepExit((response) => {
          if (response.direction === 'up') {
            this.gsapFrameTimeline.reverse();
          }
        });
    },
  },
};
</script>
<template>
  <div class="frame-animation">
    <div class="frame-animation__top">
      <div class="frame-animation__top-expand" />
    </div>
    <div class="frame-animation__sides frame-animation__sides-left" />
    <div class="frame-animation__sides frame-animation__sides-right" />
    <div class="frame-animation__bottom" />
  </div>
</template>
